import SettingsPageContainer from '../../../container/settings';

const settingsRoute = [
  {
    path: 'settings',
    element: <SettingsPageContainer />,
  },
];

export default settingsRoute;
